import {SurveyCheckGreen, videoOverlayIcon} from '@jobseeker/lotus/icons';
import {Box, IconButton, Typography, styled} from '@mui/material';
import {useEffect, useMemo, useRef, useState} from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import ButtonV2 from '@jobseeker/lotus/elements/ButtonV2';
import {
  useAlertCallback,
  useComponentTimer,
  useIsLargeDevice,
  useMediaStream,
} from '@jobseeker/lotus/hooks';
import {RecordingOverlay, IconContainer} from '../common';
import ReactPlayer from 'react-player';
import {BsCameraVideo} from 'react-icons/bs';
import {VscDebugRestart} from 'react-icons/vsc';
import {FaRegStopCircle, FaPlay} from 'react-icons/fa';
import {FiUpload} from 'react-icons/fi';
import {FaPause} from 'react-icons/fa6';
import LinearProgress from '@mui/material/LinearProgress';
import {getRefTagAndOrigin, handleTracking} from '@jobseeker/common-core/utils';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

// import RecordRTC from 'recordrtc';
// import dynamic from 'next/dynamic';
// import RecordRTC from 'recordrtc';
// const RecordRTC = dynamic(()=>import('recordrtc'),{ssr:false});

const Button = styled(ButtonV2)(({theme}) => ({
  padding: theme.spacing(1, 3),
}));

export const VideoRecorder = ({onMediaPermission, ...props}: any) => {
  const theme = useWrappedTheme();
  const {isMinimalist, setMinimalistView, playUrl} = props;
  // console.log('🚀 ~ playUrl:', playUrl);
  const [isRecording, setIsRecording] = useState(false);
  const [showBackdrop, setShowBackdrop] = useState(true);
  const [recordDuration, setRecordDuration] = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const recordDurationRef = useRef<any>();
  const actionButtonRef = useRef<any>();
  const [disableClick, setDisableClick] = useState(true);
  const [minimalistViewCallback, setMinimalistViewCallback] = useState<any>();

  const startRecordCounter = () => {
    recordDurationRef.current = setInterval(() => {
      setRecordDuration(count => count + 1);
    }, 1000);
  };

  const scrollToActionButton = () => actionButtonRef?.current?.scrollIntoView();

  useEffect(() => {
    if (!isRecording) {
      clearInterval(recordDurationRef.current);
      recordDurationRef.current = null;
    }
    if (isRecording && !recordDurationRef.current) {
      startRecordCounter();
    }
    if (recordDuration > 5) {
      setDisableClick(false);
    }
  }, [isRecording, recordDuration]);

  const onRecordingStop = () => {
    setIsRecording(false);
    if (props.onRecordingStop) {
      props.onRecordingStop();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowBackdrop(false);
    }, 4000);
    const handleSwitchEvent = (event: any) => {
      if (event?.detail?.delete) {
        handleRestartClick();
      }
      if (recordedBlob && props.isUploaded) {
        stopVideoStream();
      }
    };
    window.addEventListener('stepSwitchEvent', handleSwitchEvent);
    return () =>
      window.removeEventListener('stepSwitchEvent', handleSwitchEvent);
  }, []);

  const initRecord = () => {
    startRecording();
    setIsRecording(true);
    if (props.onRecordingStart) {
      props.onRecordingStart();
    }
  };

  useEffect(() => {
    if (actionButtonRef.current) {
      // scrollToActionButton();
    }
  }, [actionButtonRef]);

  useEffect(() => {
    if (!playUrl) {
      startWebcam();
    }
    return () => {
      stopVideoStream();
    };
  }, []);

  const {Timer, startTimer, timerCompleted} = useComponentTimer({
    callback: initRecord,
    onTimerStart: () => {
      setShowBackdrop(false);
    },
  });
  const isLarge = useIsLargeDevice();
  const streamRecorder = async (stream: any) => {
    const RecordRTC = (await import('recordrtc')).default;
    return new RecordRTC(stream, {
      type: 'video',
      disableLogs: true,
      mimeType: 'video/mp4',
      recorderType: RecordRTC.MediaStreamRecorder,
      // bitrate: 100 * 10,
    });
  };
  const {
    videoRef,
    startRecording,
    stopRecording,
    recordedBlob,
    compressedRecordedBlob,
    stopVideoStream,
    startWebcam,
    reset,
    toggleBackgroundBlur,
  } = useMediaStream({
    videoConfig: isLarge
      ? {
          width: {ideal: 1280},
          height: {ideal: 649},
          aspectRatio: 75 / 38,
        }
      : {
          width: {ideal: 649},
          height: {ideal: 1280},
          aspectRatio: 38 / 75,
        },
    audioConfig: true,
    recordingDuration: 60,
    onRecordingStop,
    streamRecorder,
    onMediaPermission,
  });

  const formattedDuration = useMemo(() => {
    const minutes = Math.floor(recordDuration / 60);
    let seconds = recordDuration;
    if (minutes > 0) {
      seconds = seconds - minutes * 60;
    }
    return `${(minutes > 9 ? '' : '0') + minutes}:${
      (seconds > 9 ? '' : '0') + seconds
    }`;
  }, [recordDuration]);

  const handleRestartClick = async () => {
    try {
      resetComponent();
    } catch (error) {}
    if (props.onRestartClick) {
      props.onRestartClick();
    }
  };

  const handleFinishClick = () => {
    stopRecording();
    if (props.onFinishClick) {
      props.onFinishClick();
    }

    // Send jsFinish GA event
    if (isAppIimjobs || typeof location === 'undefined') {
      return;
    }

    handleTracking('jsFinish', {
      event_category: 'Round Zero',
      Origin: location?.pathname ?? '',
      Source: 'Resume',
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Type: 'Audio',
    });
  };
  const handleUploadClick = () => {
    if (props.onUploadClick) {
      props.onUploadClick(compressedRecordedBlob || recordedBlob);
    }

    if (isAppIimjobs || typeof location === 'undefined') {
      return;
    }

    handleTracking('jsUpload', {
      event_category: 'Round Zero',
      Origin: location?.pathname ?? '',
      Source: 'Resume',
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Type: 'Video',
    });
  };
  const togglePlayback = () => {
    setIsVideoPlaying(!isVideoPlaying);
  };

  useEffect(() => {
    if (isMinimalist && minimalistViewCallback) {
      minimalistViewCallback();
    }
    if (!isMinimalist && isRecording) {
      resetComponent();
    }
  }, [isMinimalist]);

  const resetComponent = () => {
    reset();
    setIsRecording(false);
    // setShowBackdrop(true);
    setRecordDuration(0);
    setIsVideoPlaying(false);
  };

  const {origin} = getRefTagAndOrigin();
  const handleStartRecordingClick = () => {
    console.log('wtf');

    if (!isAppIimjobs) {
      handleTracking('jsGuidelines', {
        Origin: `${origin}`,
        Source: 'Resume',
        UserId: sessionStorage.getItem('userId') || 'NA',
        event_category: 'Round Zero',
        Type: 'Video',
      });
      handleTracking('jsPause', {
        Origin: `${origin}`,
        Source: 'Resume',
        UserId: sessionStorage.getItem('userId') || 'NA',
        event_category: 'Round Zero',
        Type: 'Video',
      });
      handleTracking('jsPlay', {
        Origin: `${origin}`,
        Source: 'Resume',
        UserId: sessionStorage.getItem('userId') || 'NA',
        event_category: 'Round Zero',
        Type: 'Video',
      });
      handleTracking('jsRerecord', {
        Origin: `${origin}`,
        Source: 'Resume',
        UserId: sessionStorage.getItem('userId') || 'NA',
        event_category: 'Round Zero',
        Type: 'Video',
      });
    }
    if (isLarge) {
      startTimer();
    } else {
      setMinimalistViewCallback(startTimer);
      setMinimalistView('Round Zero- Record your Resume');
    }
    setDisableClick(true);

    try {
      if (isAppIimjobs) {
        return;
      }

      handleTracking('jsStartRecording', {
        event_category: 'Round Zero',
        Origin: window?.location?.pathname ?? '',
        Source: 'Resume',
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Type: 'Video',
      });
    } catch (err) {
      console.error('Error occurred while starting the recording', err);
    }
  };

  const [RestartAlert, toggleRestartAlert] = useAlertCallback({
    primaryAction: 'Restart',
    secondaryAction: 'Cancel',
    subtitle: 'Alert : This will delete your current recording',
    title: 'Are you sure you want to restart?',
    primaryCallback: handleRestartClick,
  });

  return (
    <>
      <Box width={'100%'}>
        <Box
          height={
            isMinimalist
              ? `calc(100vh - ${
                  props?.source === 'onboarding' ? '420' : '215'
                }px)`
              : isLarge
                ? 380
                : 180
          }
          position={'relative'}
          overflow={'hidden'}
          borderRadius={3}
          sx={{
            backgroundColor: '#000',
            // '.playIcon': {
            //   display: 'none',
            // },
            // ':hover': {
            //   '.playIcon': {
            //     display: 'flex',
            //   },
            // },

            ...(isVideoPlaying
              ? {
                  '& > .playIcon': {
                    opacity: 0,
                  },
                  ':hover': {
                    '& > .playIcon': {
                      opacity: 1,
                    },
                  },
                }
              : {}),
          }}
        >
          {!recordedBlob && !playUrl ? (
            <Box
              component={'video'}
              src={''}
              autoPlay
              muted
              ref={videoRef}
              playsInline
              webkit-playsinline={'true'}
              sx={{
                width: '100%',
                height: 'inherit',
                objectFit: 'cover',
                transform: 'scaleX(-1)',
                filter: !showBackdrop ? 'unset' : 'blur(10px)',
              }}
            />
          ) : (
            <ReactPlayer
              url={recordedBlob ? URL?.createObjectURL(recordedBlob) : playUrl}
              width="100%"
              height="inherit"
              objectFit="cover"
              style={{
                // transform: 'scaleX(-1)',
                width: '100% !important',
                height: 'inherit !important',
                objectFit: 'cover',
              }}
              onEnded={() => setIsVideoPlaying(false)}
              playing={isVideoPlaying}
              controls={false}
              playsinline={true}
              pip={false}
              disablePictureInPicture
            />
          )}
          {Timer}
          {(isRecording || recordedBlob) && !isVideoPlaying && (
            <RecordingOverlay
              lapsedDuration={formattedDuration}
              totalDuration="01:00"
              isRecording={isRecording}
            />
          )}
          {showBackdrop && !props.isUploaded && (
            <Box
              onClick={() => {
                setShowBackdrop(false);
              }}
              sx={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                // zIndex: 1,
                backgroundColor: '#000000B2',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box textAlign={'center'} px={{xxs: 2, md: 0}}>
                <Image
                  // component={Image}
                  src={videoOverlayIcon}
                  width={isLarge ? 80 : 64}
                  height={isLarge ? 80 : 64}
                  alt="overlay-icon"
                />
                <Typography
                  fontWeight={400}
                  fontSize={{xxs: 10, md: 12}}
                  mt={1}
                  color={'primary.contrastText'}
                >
                  Be in a well -lit and preferably silent area.
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontSize={{xxs: 12, md: 14}}
                  mt={1}
                  color={'primary.contrastText'}
                >
                  Click here to dismiss
                </Typography>
              </Box>
            </Box>
          )}
          {(recordedBlob || playUrl) && (
            <IconContainer className="playIcon" onClick={togglePlayback}>
              {isVideoPlaying ? <FaPause /> : <FaPlay />}
            </IconContainer>
          )}
          {props.isUploading && (
            <Box
              sx={{
                position: 'absolute',
                zIndex: 2,
                bottom: 0,
                left: 0,
                width: '100%',
              }}
              px={2}
            >
              <Box textAlign={'right'}>
                <Typography
                  fontSize={16}
                  lineHeight={'30px'}
                  fontWeight={600}
                  color={'#fff'}
                  sx={{
                    textShadow: '0px 3px 4px #00000070',
                  }}
                >
                  Uploading
                </Typography>
              </Box>
              <Box width={'100%'} mb={2}>
                <LinearProgress
                  sx={{
                    height: 6,
                    borderRadius: 5,
                    backgroundColor: '#fff',
                    '.MuiLinearProgress-bar': {backgroundColor: 'text.primary'},
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
        <Box
          ref={actionButtonRef}
          display={'flex'}
          mt={props?.source === 'onboarding' ? 4.125 : 1.5}
          mb={props?.source === 'onboarding' ? -1.5 : 0}
          textAlign={'center'}
          gap={{xxs: 1.5, md: 2}}
          justifyContent={'center'}
        >
          {!isRecording && !recordedBlob && !playUrl ? (
            // {false ? (
            isAppIimjobs ? (
              <Button
                variant="contained"
                disabled={!timerCompleted || props.disabled}
                color="secondary"
                onClick={handleStartRecordingClick}
              >
                <BsCameraVideo /> &nbsp;&nbsp;Start Recording
              </Button>
            ) : (
              <Button
                variant="contained"
                disabled={!timerCompleted || props.disabled}
                color="secondary"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: isAppIimjobs ? 'default' : 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                  },
                  borderRadius: 0.5,
                  borderColor: theme.palette.primary.main,
                }}
                size="large"
                onClick={handleStartRecordingClick}
              >
                <BsCameraVideo /> &nbsp;&nbsp;Start Recording
              </Button>
            )
          ) : (
            <>
              {recordedBlob || playUrl ? (
                <>
                  {isAppIimjobs ? (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={
                        props.isUploaded
                          ? toggleRestartAlert
                          : handleRestartClick
                      }
                      disabled={props.disabled}
                    >
                      <VscDebugRestart /> &nbsp;&nbsp;
                      {props?.source === 'onboarding'
                        ? 'Record Again'
                        : 'Restart'}
                    </Button>
                  ) : (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={
                        props.isUploaded
                          ? toggleRestartAlert
                          : handleRestartClick
                      }
                      sx={{
                        borderRadius: '4px',
                      }}
                      disabled={props.disabled}
                    >
                      <VscDebugRestart /> &nbsp;&nbsp;
                      {props?.source === 'onboarding'
                        ? 'Record Again'
                        : 'Restart'}
                    </Button>
                  )}
                  {props.isUploaded && props?.source !== 'onboarding' ? (
                    <Typography
                      fontSize={{xxs: 14, md: 16}}
                      fontWeight={500}
                      display={'flex'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      gap={1}
                    >
                      <Box
                        component={'img'}
                        src={SurveyCheckGreen}
                        width={{xxs: 26, md: 32}}
                        height={{xxs: 26, md: 32}}
                      />
                      {/* {isLarge ? 'Your Video resume is uploaded!' : 'Uploaded!'} */}
                      Uploaded
                    </Typography>
                  ) : isAppIimjobs ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleUploadClick}
                      disabled={props.disabled}
                    >
                      <FiUpload />
                      &nbsp;&nbsp;Upload
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      onClick={handleUploadClick}
                      disabled={props.disabled}
                      variant={isAppIimjobs ? 'contained' : 'outlined'}
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: isAppIimjobs ? 'default' : 'white',
                        '&:hover': {
                          color: 'white',
                          backgroundColor: theme.palette.primary.main,
                          borderColor: theme.palette.primary.main,
                        },
                        borderRadius: 0.5,
                        borderColor: theme.palette.primary.main,
                      }}
                      size="large"
                    >
                      <FiUpload />
                      &nbsp;&nbsp;Upload
                    </Button>
                  )}
                </>
              ) : isAppIimjobs ? (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleFinishClick}
                  disabled={props.disabled || disableClick}
                >
                  <FaRegStopCircle />
                  &nbsp;&nbsp;Finish
                </Button>
              ) : (
                <Button
                  variant={isAppIimjobs ? 'contained' : 'outlined'}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: isAppIimjobs ? 'default' : 'white',
                    '&:hover': {
                      color: 'white',
                      backgroundColor: theme.palette.primary.main,
                      borderColor: theme.palette.primary.main,
                    },
                    borderRadius: 0.5,
                    borderColor: theme.palette.primary.main,
                  }}
                  size="large"
                  color="secondary"
                  onClick={handleFinishClick}
                  disabled={props.disabled || disableClick}
                >
                  <FaRegStopCircle />
                  &nbsp;&nbsp;Finish
                </Button>
              )}
            </>
          )}
        </Box>
      </Box>
      <RestartAlert />
    </>
  );
};

export default VideoRecorder;
